import { theme } from "../../../../../helpers/theme";
import aboutUsImage from "../../../../../assets/icons/img_with_button.svg"
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { url } from "../../../../../utils/url";
import { StyledButton } from "../../../../../components/Button/button";



export const ImageSection_ = () => {
    const navigate = useNavigate();
    return (
        <div style={{
            marginTop: '80px',
        }}>
            <ImageSection
                style={{
                    backgroundImage: `url(${aboutUsImage})`,
                    backgroundSize: 'cover',
                }}>

                <ImageTitle>Przestrzeń  magazynowa <br /> do wynajęcia</ImageTitle>
                <StyledButton
                    onClick={() => navigate(url.offerForm)}
                    sx={{
                        width: '194px',
                        height: '56px',
                        fontSize: '16px',
                        lineHeight: '24px',
                    }}
                >
                    Złóż zamówienie
                </StyledButton>
            </ImageSection >
        </div >

    );
};


const ImageTitle = styled.div`
font-family:${theme.fonts.interRegular};
font-weight:${theme.fontWeight.big};
color:${theme.colors.white};
width: 100%;
margin-bottom:24px;
margin-top:5px;
font-size:46px;
line-height:52px;

 @media(max-width: 260px) {
    font-size:32px;
    line-height:40px;
    width: 100%;
 }
  @media(min-width: 1024px) {
    font-size:64px;
    line-height:72px;
    width: 70%;
  }
`
const ImageSection = styled.div`
padding:40px 48px;
display: flex;
flex-direction: column;
justify-content: start;
border-radius: 8px;
background-repeat: no-repeat;
background-position: center; 
height:25rem;
`;

